import { fetchAuthSession } from 'aws-amplify/auth'
import axios from 'axios';
import apiurl from "./apiweb.js"


const obj = {

    createFactura: async (params) => {

        console.log(params);
        // return;
        const token = (await fetchAuthSession()).tokens?.idToken?.toString();
        return axios.post(apiurl + "submitjsonfac",
            {
                ...params
            }
            ,
            {
                headers: {
                    'content-type': 'application/json',
                    'Authorization': "Bearer " + token,
                },
                crossdomain: true
            });
    },
    previewFactura: async (data) => {

        const token = (await fetchAuthSession()).tokens?.idToken?.toString();

        return axios.post(
            `${apiurl}generarpdffactura`,
            JSON.stringify(data),
            {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${token}`,
                },
                crossdomain: true,
            }
        );
    },
    getActeco: async () =>
        axios({
            method: 'GET',
            url: apiurl + '/getacteco',
            headers: {
                'content-type': 'application/json',
                Authorization: 'Bearer ' + (await fetchAuthSession()).tokens?.idToken?.toString(),
            },
            crossdomain: true,
        }),
}

export default obj;